import "./RefreshButton.scss";
import Button from "../../Components/Button/Button";
import { BiRefresh } from "react-icons/bi";

import React from "react";

class RefreshButton extends React.Component {
  render() {
    const { newContentAvailable, onClick } = this.props;
    return (
      <Button
        onClick={onClick}
        className={
          "refreshbutton" + (newContentAvailable ? " newContentAvailable" : "")
        }
      >
        <BiRefresh size="4x" />
      </Button>
    );
  }
}

export default RefreshButton;
